import * as React from 'react';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import DoorFrontIcon from '@mui/icons-material/DoorFront';
import HomeIcon from '@mui/icons-material/Home';
import SolarPowerIcon from '@mui/icons-material/SolarPower';
import { height } from '@mui/system';
import Portal from '@mui/material/Portal';

export default function Navigation(props) {
    const {setCurrentScreen, currentScreen} = props;

    return (
        <Portal>
            <Paper id="bottom-nav" sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1300 }} elevation={3}>
                <Box sx={{ width: "100%", bgcolor: 'black' }}>
                    <BottomNavigation
                        showLabels
                        value={currentScreen}
                        onChange={(event, newValue) => {
                            setCurrentScreen(newValue);
                        }}
                    >
                        <BottomNavigationAction  label="Prospecting"  icon={<DoorFrontIcon />} />
                        <BottomNavigationAction  label="leads" icon={<HomeIcon />} />
                        <BottomNavigationAction  label="closed" icon={<SolarPowerIcon />} />
                    </BottomNavigation>
                </Box>
            </Paper>
        </Portal>
    );
}